export class CountriesLang {
    public CA: string;
    public CO: string;
    public MX: string;
    public US: string;
}


// WEBPACK FOOTER //
// ./src/resources/CountriesLang.ts